var map = {
	"./Easilys.png": 6062,
	"./Guestonline.png": 6063,
	"./Image_pola.svg": 391,
	"./Image_simple.svg": 306,
	"./LaFourchette.png": 6064,
	"./Laddition.png": 6065,
	"./Snapshift.png": 6066,
	"./UberEats.png": 6067,
	"./bardistribution.jpg": 6068,
	"./barratio.jpg": 6069,
	"./combo.png": 6070,
	"./commandeenligne-pay+.png": 6071,
	"./como.png": 6072,
	"./dashboard_bgd.png": 6073,
	"./deleteIcon.svg": 230,
	"./deliverect.png": 6074,
	"./deliveroo.png": 6075,
	"./dood.png": 6076,
	"./dvore.png": 6077,
	"./eviivo.png": 6078,
	"./fleche-bas.svg": 6079,
	"./gstock.png": 6080,
	"./guestonline-1.png": 6081,
	"./guestonline-2.png": 6082,
	"./inpulse.png": 6083,
	"./kds.png": 6084,
	"./koust.png": 6085,
	"./laddition-commande-en-ligne.png": 6086,
	"./laddition-paiement-a-table.png": 6087,
	"./ladditionAchats.png": 6088,
	"./ladditionMenu.png": 6089,
	"./ladditionReservation.png": 6090,
	"./lafourchette-1.png": 6091,
	"./lafourchette-2.png": 6092,
	"./lafourchette-3.png": 6093,
	"./lafourchette-4.png": 6094,
	"./lafourchette-5.png": 6095,
	"./lock_open.svg": 392,
	"./logo.png": 393,
	"./mews.png": 6096,
	"./misterbooking.png": 6097,
	"./mycawan.svg": 6098,
	"./netresto-1.png": 6099,
	"./netresto-2.png": 6100,
	"./netresto-3.png": 6101,
	"./netresto-4.png": 6102,
	"./netresto-5.png": 6103,
	"./netresto.png": 6104,
	"./obypay.png": 6105,
	"./otter.png": 6106,
	"./pennylane.png": 6107,
	"./pongo.png": 6108,
	"./rushour.png": 6109,
	"./skello.png": 6110,
	"./snapshift-1.png": 6111,
	"./snapshift-2.png": 6112,
	"./snapshift-3.png": 6113,
	"./snapshift-4.png": 6114,
	"./snapshift-5.png": 6115,
	"./snapshift-6.png": 6116,
	"./sunday.png": 6117,
	"./tabesto.png": 6118,
	"./tessi.png": 6119,
	"./uberEats-1.png": 6120,
	"./uberEats-2.png": 6121,
	"./uberEats-3a.png": 6122,
	"./uberEats-3b.png": 6123,
	"./uberEats-3c.png": 6124,
	"./uberEats-4.png": 6125,
	"./valider.svg": 6126,
	"./yokitup.png": 6127,
	"./zenchef2.png": 6128
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223;